export const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

export const formItemLayout2 = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
  },
};

export const formItemLayout3 = {
  labelCol: {
    span: 7
  },
  wrapperCol: {
    span: 17,
  },
  colon: false
};